module.exports = __webpack_public_path__ + "img/upload-icon.4936ca9b.svg";